import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
  namespace: "App.Events",
  broadcaster: "pusher",
  key: process.env.VUE_APP_WEBSOCKETS_KEY,
  wsHost: process.env.VUE_APP_WEBSOCKETS_HOST,
  wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
  wssPort: process.env.VUE_APP_WEBSOCKETS_PORT,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ["ws", "wss"],
  authEndpoint: process.env.VUE_APP_BASE_API + "/broadcasting_auth",
  auth: {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  },
  channelAuthorization: {
    endpoint: process.env.VUE_APP_BASE_API + "/broadcasting_auth",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  },
});
